module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img37.1d68b3af.jpg";